import Link, { type LinkProps } from 'next/link';
import type { AnchorHTMLAttributes, ReactNode } from 'react';

import { cn } from '@/lib/utils';

type ExternalLinkProps = LinkProps &
  Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> & {
    children: ReactNode;
    href: string;
  };

function opensOnThisPage(href: string) {
  return href.startsWith('mailto:') || href.startsWith('tel:');
}

export default function ExternalLink({
  href,
  children,
  className,
  target: _target,
  rel: _rel,
  ...props
}: ExternalLinkProps) {
  const classes = cn('text-aareal-aval underline hover:text-aareal-aval-light', className);

  if (opensOnThisPage(href)) {
    return (
      <a href={href} className={classes} {...props}>
        {children}
      </a>
    );
  }

  return (
    <Link href={href} target="_blank" rel="noopener noreferrer" className={classes} {...props}>
      {children}
    </Link>
  );
}
